// extracted by mini-css-extract-plugin
export default {"panel":"SidePanel_panel__UhLb8","close":"SidePanel_close__tlZOK"};